import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import SchoolIcon from '@mui/icons-material/School';
import DevicesIcon from '@mui/icons-material/Devices';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import CastForEducationIcon from '@mui/icons-material/CastForEducation';
import { useEffect, useState } from "react";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import dayjs from "dayjs";
import StepButton from "@mui/material/StepButton";
import Paper from "@mui/material/Paper";
import Typography from '@mui/material/Typography';
import useStudentContext from 'hooks/useStudentContext';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';


// interface PropTypes {

// }

function ProgressCard() {
    const { courseEnrollments } = useStudentContext();
    const [activeStep, setActiveStep] = useState(0);

    useEffect(() => {
        setActiveStep(courseEnrollments.findIndex(enrollment => !!enrollment?.completed_at));
    }, [courseEnrollments]);

    const getIcon = (courseType: 'behind_the_wheel' | 'in_person' | 'synchronous_online' | 'fully_online',) => {
        if (courseType === 'in_person') {
            return <SchoolIcon />;
        } else if (courseType === 'fully_online') {
            return <DevicesIcon />;
        } else if (courseType === 'behind_the_wheel') {
            return <DriveEtaIcon />;
        } else if (courseType === 'synchronous_online') {
            return <CastForEducationIcon />;
        }
        return <SchoolIcon />;
    };


    dayjs.extend(duration);
    dayjs.extend(relativeTime);
    return (
        <Paper sx={{
            m: 0,
            py: 2,
            borderRadius: 0
        }}>
            <Stepper activeStep={activeStep} alternativeLabel nonLinear>
                {courseEnrollments.map((enrollment, index) => {
                    const otherPackageCourses = courseEnrollments.filter(pkgCourse => enrollment.package_course_package_id === pkgCourse.package_course_package_id);
                    const needToCompleteFirst = otherPackageCourses.filter(pkgCourse => pkgCourse?.requisite_group < enrollment?.requisite_group && !pkgCourse.completed_at);
                    const performanceTimeCompleted = dayjs.duration(enrollment?.performance_time_completed ?? { minutes: 0 });
                    const performanceTimeScheduled = dayjs.duration(enrollment?.performance_time_scheduled ?? { minutes: 0 });
                    const observationTimeCompleted = dayjs.duration(enrollment?.performance_time_completed ?? { minutes: 0 });
                    const observationTimeScheduled = dayjs.duration(enrollment?.performance_time_scheduled ?? { minutes: 0 });
                    const performanceTimeRequired = dayjs.duration(enrollment?.course_completion_criteria?.performance_time_required ?? { minutes: 0 });
                    const observationTimeRequired = dayjs.duration(enrollment?.course_completion_criteria?.observation_time_required ?? { minutes: 0 });
                    const showTimeLeftToSchedule = ['manual', 'self_scheduled'].includes(enrollment?.course?.schedule_type);


                    return (
                        <Step
                            key={enrollment?.id}
                            completed={!!enrollment?.completed_at}
                            disabled={needToCompleteFirst?.length > 0}
                            sx={{
                                color: enrollment?.completed_at ? 'success.main' : undefined
                            }}
                        >
                            <StepButton
                                onClick={() => { setActiveStep(index) }}
                                optional={
                                    <>
                                        {enrollment?.course?.title !== enrollment?.course_section?.title && (
                                            <Typography variant="subtitle1">
                                                {enrollment?.course_section?.title}
                                            </Typography>
                                        )}

                                        <Stack spacing={1}>

                                            <Box>
                                                {!enrollment?.completed_at && performanceTimeRequired.asMilliseconds() > 0 && (
                                                    <Typography variant="subtitle2" color="warning.main" lineHeight={1}>
                                                        {`${performanceTimeCompleted.asHours()} / ${performanceTimeRequired.asHours()} ${enrollment?.course?.course_type === 'behind_the_wheel' ? 'Driving' : 'Performance'} Hours Completed`}
                                                    </Typography>
                                                )}

                                                {!enrollment?.completed_at && performanceTimeRequired.asMilliseconds() > 0 && showTimeLeftToSchedule && (
                                                    <Typography variant="subtitle2" color="warning.main" lineHeight={1}>
                                                        {`${performanceTimeRequired.subtract(performanceTimeScheduled).asHours()} ${enrollment?.course?.course_type === 'behind_the_wheel' ? 'Driving' : 'Performance'} Hours Left To Schedule`}
                                                    </Typography>
                                                )}
                                            </Box>

                                            <Box>
                                                {!enrollment?.completed_at && observationTimeRequired.asMilliseconds() > 0 && (
                                                    <Typography variant="subtitle2" color="warning.main" lineHeight={1}>
                                                        {`${observationTimeCompleted.asHours()} / ${observationTimeRequired.asHours()} Observation Hours Completed`}
                                                    </Typography>
                                                )}

                                                {!enrollment?.completed_at && observationTimeRequired.asMilliseconds() > 0 && showTimeLeftToSchedule && (
                                                    <Typography variant="subtitle2" color="warning.main" lineHeight={1}>
                                                        {`${observationTimeRequired.subtract(observationTimeScheduled).asHours()} Observation Hours Left To Schedule`}
                                                    </Typography>
                                                )}
                                            </Box>

                                            {enrollment?.completed_at && (
                                                <Typography variant="subtitle2" color="success.main">
                                                    {`Completed ${dayjs(enrollment?.completed_at).format('MMMM Do, YYYY')}`}
                                                </Typography>
                                            )}

                                            {enrollment.must_complete_by && needToCompleteFirst?.length === 0 && (
                                                <Typography variant="subtitle2" fontWeight="bold">
                                                    {`Must Complete By ${dayjs(enrollment.must_complete_by).format("MMMM Do, YYYY")}`}
                                                    {/* {`${needToCompleteFirst.map(pkgCourse => pkgCourse?.course?.title).join(', ')} Must Be Completed First`} */}
                                                </Typography>
                                            )}

                                            {needToCompleteFirst?.length > 0 && (
                                                <Typography variant="subtitle2" color="error">
                                                    {`Must Complete ${courseEnrollments?.[index - 1]?.course?.title} First`}
                                                    {/* {`${needToCompleteFirst.map(pkgCourse => pkgCourse?.course?.title).join(', ')} Must Be Completed First`} */}
                                                </Typography>
                                            )}

                                        </Stack>
                                    </>
                                }

                                icon={getIcon(enrollment?.course?.course_type)}

                            >
                                <Typography variant="h6">
                                    {enrollment?.course?.title}
                                </Typography>
                            </StepButton>
                        </Step>
                    );
                })}
            </Stepper>
        </Paper>
    );
}

export default ProgressCard;